import {
  CustomDimensionToCustomParamMap,
  CustomDimensionToUserPropertyMap,
  CustomParamToCustomDimensionMap,
  UserPropertyToCustomDimensionMap,
} from './ga4Types';
import { reverseDictionary } from '../../utils/object';

/**
 * Map of custom dimensions (UA) to user properties (GA4 / firebase)
 */
export const customDimensionToUserPropertyDictionary: CustomDimensionToUserPropertyMap =
  {
    dimension1: 'market',
    dimension8: 'lang_cod',
    dimension12: 'prime_member',
    dimension15: 'sso',
    dimension31: 'unlocked_subscription',
    dimension36: 'client_id',
    dimension59: 'edo_user_id',
    dimension66: 'cmp_ad_agreement',
    dimension71: 'push_notifications',
    dimension75: 'prime_bookings_per_user',
    dimension76: 'registered_userid',
  } as const;

/**
 * Map of user properties (GA4 / firebase) to custom dimensions (UA)
 */
export const userPropertyToCustomDimensionDictionary: UserPropertyToCustomDimensionMap =
  reverseDictionary<
    CustomDimensionToUserPropertyMap,
    UserPropertyToCustomDimensionMap
  >(customDimensionToUserPropertyDictionary, { market: null });

/**
 * Map of custom dimensions (UA) to custom params (GA4 / firebase)
 */
export const customDimensionToCustomParamDictionary: CustomDimensionToCustomParamMap =
  {
    metric1: 'number_of_passengers',
    metric2: 'number_of_adults',
    metric3: 'number_of_children',
    metric4: 'number_of_infants',
    metric5: 'duration',
    metric6: 'number_of_rooms_in_dp',
    metric7: 'days_in_advanced',
    metric8: 'gross_sale',
    dimension1: 'market', // this is a user property, but it's also an event param
    dimension2: 'departure_date',
    dimension3: 'arrival_date',
    dimension4: 'payment_method',
    dimension5: 'product_code',
    dimension6: 'transport_code',
    dimension7: null,
    dimension8: 'lang_cod', // this is a user property, but it's also an event param
    dimension9: 'site_type',
    dimension11: 'visit_id',
    dimension13: 'release_number',
    dimension14: 'beta',
    dimension15: 'sso', // this is a user property, but it's also an event param
    dimension16: null,
    dimension17: null,
    dimension18: null,
    dimension19: null,
    dimension20: null,
    dimension21: null,
    dimension22: null,
    dimension23: null,
    dimension24: null,
    dimension25: null,
    dimension26: null,
    dimension27: null,
    dimension28: null,
    dimension29: null,
    dimension30: null,
    dimension32: 'unlocked_eligibility',
    dimension33: 'mkttrack',
    dimension35: 'page_category',
    dimension38: 'searches',
    dimension39: 'r_marketing_split',
    dimension40: null,
    dimension41: 'wapbx_exp',
    dimension42: 'ticket_type',
    dimension43: 'trip_type',
    dimension44: 'trip_dates',
    dimension45: 'location',
    dimension46: 'class_type',
    dimension47: 'hotel_dates',
    dimension48: 'trip_distance',
    dimension49: 'connection_type',
    dimension50: 'touchpoint',
    dimension51: 'arrival_city_code',
    dimension52: 'departure_city_code',
    dimension53: 'screen_name',
    dimension54: 'transaction_price',
    dimension56: 'provider',
    dimension57: 'bundle_ID',
    dimension58: 'url',
    dimension60: 'car_price_split',
    dimension61: 'carrier_trip_number',
    dimension62: 'full_referrer',
    dimension63: 'misc',
    dimension64: 'booking_status',
    dimension65: 'personalized_sorting',
    dimension67: 'pricing_message',
    dimension68: 'selection_type',
    dimension69: 'checked_booking_id',
    dimension70: 'provider_product',
    dimension72: 'low_co2',
    dimension73: 'buypath',
    dimension74: 'subscription_type',
    dimension77: 'dynamic_funnel',
    dimension78: 'sso_hit',
    dimension80: 'mkt_utm_source',
    dimension81: 'mkt_utm_medium',
    dimension82: 'mkt_utm_campaign',
    dimension83: 'mkt_utm_content',
    dimension84: 'mkt_utm_term',
    dimension85: 'mkt_gclid',
    dimension86: 'mkt_channel',
    dimension87: 'subscription_prime_mode',
    dimension88: 'prime_autorenewal_status',
    dimension89: 'booking_id',
    dimension91: 'feature_context_id',
  } as const;

/**
 * Map of custom params (GA4) to custom dimensions (UA)
 */
export const mapCustomParamToCustomDimension: CustomParamToCustomDimensionMap =
  reverseDictionary<
    CustomDimensionToCustomParamMap,
    CustomParamToCustomDimensionMap
  >(customDimensionToCustomParamDictionary, {
    affiliation: null,
    coupon: null,
    event_action: null,
    event_category: null,
    event_label: null,
    market: null,
    mktsession_id: null,
    app_traffic: null,
    edo_campaign_code: null,
    smart_funnel_productstoskip: null,
    tt1: null,
    tt2: null,
    tt3: null,
    tt4: null,
    tt5: null,
    tt6: null,
    tt7: null,
    tt8: null,
    tt9: null,
    tt10: null,
    tt11: null,
    tt12: null,
    tt13: null,
    tt14: null,
    tt15: null,
  });
